var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.tagName,{tag:"component",class:[
		`b-btn b-btn--${_vm.color} b-btn--${_vm.variant}`,
		{'b-btn--minimal' : !!_vm.minimal},
		{'b-btn--not-greyed-out': _vm.disabled === 'not-greyed-out'}
	],attrs:{"href":(_vm.disabled || _vm.loading) && _vm.href ? null : _vm.href,"tabindex":!!_vm.disabled ? '-1': '0',"aria-disabled":!!_vm.disabled,"aria-busy":_vm.loading ? 'true' : 'false'},on:{"click":_setup.handleClick}},[(_vm.loading)?_c(_setup.ButtonSpinner,{staticClass:"b-btn__spinner",attrs:{"role":"presentation"}}):_vm._e(),_vm._v(" "),_c('span',{style:(_vm.loading ? 'visibility: hidden' : undefined)},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }